import { createRouter, createWebHistory } from "vue-router";
import Home from "../components/Home.vue"; // Page d'accueil

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/projects",
    name: "ProjectGrid",
    component: Home, // Utilisez le même composant pour afficher la grille
  },
  {
    path: "/vfx",
    name: "VFXGrid",
    component: Home, // Utilisez le même composant pour afficher la grille
  },
  {
    path: "/contact",
    name: "ContactModule",
    component: Home, // Utilisez le même composant pour afficher la grille
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
